module.exports = __webpack_public_path__ + "static/media/brands_pioneer.ed8c7c46.png";